import React, { useEffect, useState } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";


function PersianDatePicker(props: any) {
  const [date, setDate] = useState<DateObject | null>(null); // Type should be DateObject | null


  

  return (
    <DatePicker
      value={date}
      disabled={props.disabled}
      onChange={(selectedDate) => {
        setDate(selectedDate);
        if (selectedDate) {
           
        props.setMorakhasiDate(selectedDate.year.toString()+'/'+
        (selectedDate?.month.toString().length<2?'0'+selectedDate?.month.toString():selectedDate?.month.toString())
        +'/'+(selectedDate?.day.toString().length<2?'0'+selectedDate?.day.toString():selectedDate?.day.toString()));
        

   
        }
      }} // This ensures type compatibility
      calendar={persian}
      locale={persian_fa}
      
      calendarPosition="bottom-right"
    />
  );
}

export default PersianDatePicker;
